import React, { useRef } from 'react'
import EledoArticleView from './EledoArticleView'
import { EledoModal } from 'components/library'
import styles from './EledoArticlesModal.module.scss';
import useArticleHistory from 'hooks/useArticleHistory';

export const EledoArticlesModal = ({root, path, modalDisplayed, onDismiss} : {root: string, path: string, modalDisplayed: boolean, onDismiss: Function}) => {
  const history = useArticleHistory(path)
  const scrollableRef = useRef<HTMLDivElement>(null)
  
  const modalContent = (
    <div style={{marginRight: '0.5rem'}}>
      <EledoArticleView root={root} path={path} history={history} scrollableRef={scrollableRef}/>
    </div>
  )
  
  const modalActions = (
    <>
    </>
  )
  
  return (
    <>
      <EledoModal wrapClass={styles.ModalWrap}
                  modalClass={styles.Modal}
                  titleClass={styles.ModalTitle}
                  actionsClass={styles.ModalActions}
                  divider={false}
                  content={modalContent}
                  displayed={modalDisplayed}
                  topless={true}
                  actions={modalActions}
                  scrollableRef={scrollableRef}
                  onDismiss={() => onDismiss()}/>
    </>
  )
}
